import React from 'react'
import styled from 'styled-components'
import TokenLogo from '../TokenLogo'

export default function DoubleTokenLogo({ a0, a1, a0Name, a1Name, size = 24, margin = false, coinName }) {
  const TokenWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    margin-right: ${({ sizeraw, margin }) => margin && (sizeraw / 3 + 8).toString() + 'px'};
  `

  const HigherLogo = styled(TokenLogo)`
    z-index: 2;
    border-radius: 10px;
  `

  const CoveredLogo = styled(TokenLogo)`
    position: absolute;
    left: ${({ sizeraw }) => (sizeraw / 2).toString() + 'px'};
    margin-left: 8px;
  `

  return (
    <TokenWrapper sizeraw={size} margin={margin}>
      <HigherLogo address={a0} coinName={a0Name} size={size.toString() + 'px'} sizeraw={size} />
      <CoveredLogo address={a1} coinName={a1Name} size={size.toString() + 'px'} sizeraw={size} />
    </TokenWrapper>
  )
}
